import type { PostContentJson } from '@_/types';
import { getSchema, getText } from '@tiptap/core';
import { Document } from '@tiptap/extension-document';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Text } from '@tiptap/extension-text';
import { UndoRedo } from '@tiptap/extensions';
import { BaseContent } from './BaseContent.ts';

const extensions = [
  Document.extend({
    content: `block+`
  }),
  Paragraph,
  Text,
  UndoRedo
];

const schema = getSchema(extensions);

export class TextPostContent extends BaseContent {
  static extensions = extensions;

  protected get schema() {
    return schema;
  }

  constructor(content: PostContentJson) {
    super(content);
  }

  static createDefaultContent(): PostContentJson {
    return {
      type: 'doc',
      content: [{ type: 'paragraph' }]
    };
  }

  static validate(content: PostContentJson): boolean {
    const doc = schema.nodeFromJSON(content);
    return getText(doc).trim().length > 0;
  }
}
